import 'whatwg-fetch';

import { LayerTypes } from '../common/layerEnums';
import moment from 'moment';
import GeoJSONFormat from 'ol/format/GeoJSON';
import GML2Format from 'ol/format/GML2';
import MVTFormat from 'ol/format/MVT';
import WMSCapabilities from 'ol/format/WMSCapabilities';
import WMTSCapabilities from 'ol/format/WMTSCapabilities';
import ImageLayer from 'ol/layer/Image';
import TileLayer from 'ol/layer/Tile';
import VectorLayer from 'ol/layer/Vector';
import VectorTileLayer from 'ol/layer/VectorTile';
import { bbox } from 'ol/loadingstrategy';
import { transformExtent } from 'ol/proj';
import Projection from 'ol/proj/Projection';
import ImageWMSSource from 'ol/source/ImageWMS';
import TileWMSSource from 'ol/source/TileWMS';
import VectorSource from 'ol/source/Vector';
import VectorTileSource from 'ol/source/VectorTile';
import WMTSSource, { optionsFromCapabilities } from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import { Api as ApiUslugi } from '../api/api-uslugi-mapowe';
import { Api as VectorLayerApi } from '../api/api-warstwy-wektorowe';
import { FEATURES_TILE_LAYERS_FEATURES_SET } from '../store/mutations.type';
import MapLayerStyleBuilder from './MapLayerStyleBuilder';
import TileGrid from "ol/tilegrid/TileGrid";
const settings = require('../api/SettingsInstance');
let contextInstance = require('../api/ContextInstance.js').default;

('use strict');

const layerNameToHistoricalLayerName = {
  LINIOWA_ISTNIEJACA: 'historia_liniowa_it',
  LINIOWA_PLANOWANA: 'historia_liniowa_rb',
  POWIERZCHNIOWA_ISTNIEJACA: 'historia_powierzchniowa_it',
  POWIERZCHNIOWA_PLANOWANA: 'historia_powierzchniowa_rb',
  PUNKTOWA_ISTNIEJACA: 'historia_punktowa_it',
  PUNKTOWA_PLANOWANA: 'historia_punktowa_rb'
};

export default class MapLayerBuilder {
  constructor(layer, apiStyle, coordinateSystem) {
    this.layer = layer;
    this.style = apiStyle;
    this.coordinateSystem = coordinateSystem;
    this.historicalLayerName =
      layerNameToHistoricalLayerName[this.layer.datasource];
  }

  getDefaultCapabilities(){
    let url = this.layer.url ? this.layer.url : null;
    let layerTitle = this.layer.title ? this.layer.title : null;
    let layerName = this.layer.names ? this.layer.names[0] : null;
	var ldef = {"ServiceIdentification" : {"Title" : "WMTS","Abstract" : "","ServiceType" : "OGC WMTS","ServiceTypeVersion" : "1.0.0","Fees" : "NONE","AccessConstraints" : "NONE"},"ServiceProvider" : {"ProviderName" : "UKE","ProviderSite" : "https://pitmap.uke.gov.pl","ServiceContact" : {"ContactInfo" : {"Address" : {}
}}},"OperationsMetadata" : {"GetCapabilities" : {"DCP" : {"HTTP" : {"Get" : [{"href" : url,"Constraint" : [{"name" : "GetEncoding","AllowedValues" : {"Value" : ["KVP"]}}]}]}}},"GetTile" : {"DCP" : {"HTTP" : {"Get" : [{"href" : url,"Constraint" : [{"name" : "GetEncoding","AllowedValues" : {"Value" : ["KVP"]}}]}]}}},"GetFeatureInfo" : {"DCP" : {"HTTP" : {"Get" : [{"href" : url,"Constraint" : [{"name" : "GetEncoding","AllowedValues" : {"Value" : ["KVP"]}}]}]}}}},"version" : "1.0.0","Contents" : {"Layer" : [{"Title" : layerTitle,"Identifier" : layerName,"Style" : [{"Identifier" : "","isDefault" : true}],"Format" : ["image/png","image/jpeg","application/json;type=geojson","application/vnd.mapbox-vector-tile"],"TileMatrixSetLink" : [{"TileMatrixSet" : "EPSG:2180","TileMatrixSetLimits" : [{"TileMatrix" : "EPSG:2180:0","MinTileRow" : 0,"MaxTileRow" : 0,"MinTileCol" : 0,"MaxTileCol" : 0},
{"TileMatrix" : "EPSG:2180:1","MinTileRow" : 0,"MaxTileRow" : 1,"MinTileCol" : 0,"MaxTileCol" : 1},
{"TileMatrix" : "EPSG:2180:2","MinTileRow" : 0,"MaxTileRow" : 2,"MinTileCol" : 0,"MaxTileCol" : 2},
{"TileMatrix" : "EPSG:2180:3","MinTileRow" : 0,"MaxTileRow" : 5,"MinTileCol" : 0,"MaxTileCol" : 5},
{"TileMatrix" : "EPSG:2180:4","MaxTileRow" : 10,"MinTileCol" : 0,"MaxTileCol" : 11},
{"TileMatrix" : "EPSG:2180:5","MaxTileRow" : 21,"MinTileCol" : 1,"MaxTileCol" : 22},
{"TileMatrix" : "EPSG:2180:6","MaxTileRow" : 53,"MinTileCol" : 3,"MaxTileCol" : 57},
{"TileMatrix" : "EPSG:2180:7","MaxTileRow" : 107,"MinTileCol" : 6,"MaxTileCol" : 114},
{"TileMatrix" : "EPSG:2180:8","MaxTileRow" : 214,"MinTileCol" : 13,"MaxTileCol" : 229},
{"TileMatrix" : "EPSG:2180:9","MaxTileRow" : 535,"MinTileCol" : 32,"MaxTileCol" : 573},
{"TileMatrix" : "EPSG:2180:10","MaxTileRow" : 1069,"MinTileCol" : 65,"MaxTileCol" : 1146},
{"TileMatrix" : "EPSG:2180:11","MaxTileRow" : 2673,"MinTileCol" : 164,"MaxTileCol" : 2866},
{"TileMatrix" : "EPSG:2180:12","MaxTileRow" : 5346,"MinTileCol" : 329,"MaxTileCol" : 5732},
{"TileMatrix" : "EPSG:2180:13","MaxTileRow" : 10692,"MinTileCol" : 659,"MaxTileCol" : 11464},
{"TileMatrix" : "EPSG:2180:14","MaxTileRow" : 21383,"MinTileCol" : 1319,"MaxTileCol" : 22928},
{"TileMatrix" : "EPSG:2180:15","MaxTileRow" : 42766,"MinTileCol" : 2639,"MaxTileCol" : 45856}]},
{"TileMatrixSet" : "EPSG2180v2","TileMatrixSetLimits" : [{"TileMatrix" : "EPSG2180v2:0","MinTileRow" : 0,"MaxTileRow" : 0,"MinTileCol" : 0,"MaxTileCol" : 0},
{"TileMatrix" : "EPSG2180v2:1","MinTileRow" : 0,"MaxTileRow" : 1,"MinTileCol" : 0,"MaxTileCol" : 1},
{"TileMatrix" : "EPSG2180v2:2","MinTileRow" : 0,"MaxTileRow" : 3,"MinTileCol" : 0,"MaxTileCol" : 3},
{"TileMatrix" : "EPSG2180v2:3","MinTileRow" : 0,"MaxTileRow" : 7,"MinTileCol" : 0,"MaxTileCol" : 7},
{"TileMatrix" : "EPSG2180v2:4","MinTileRow" : 0,"MaxTileRow" : 15,"MinTileCol" : 0,"MaxTileCol" : 14},
{"TileMatrix" : "EPSG2180v2:5","MinTileRow" : 0,"MaxTileRow" : 31,"MinTileCol" : 0,"MaxTileCol" : 29},
{"TileMatrix" : "EPSG2180v2:6","MinTileRow" : 0,"MaxTileRow" : 63,"MinTileCol" : 0,"MaxTileCol" : 59},
{"TileMatrix" : "EPSG2180v2:7","MinTileRow" : 0,"MaxTileRow" : 127,"MinTileCol" : 0,"MaxTileCol" : 119},
{"TileMatrix" : "EPSG2180v2:8","MinTileRow" : 0,"MaxTileRow" : 255,"MinTileCol" : 0,"MaxTileCol" : 239},
{"TileMatrix" : "EPSG2180v2:9","MinTileRow" : 0,"MaxTileRow" : 511,"MinTileCol" : 0,"MaxTileCol" : 478},
{"TileMatrix" : "EPSG2180v2:10","MinTileRow" : 0,"MaxTileRow" : 1023,"MinTileCol" : 0,"MaxTileCol" : 957},
{"TileMatrix" : "EPSG2180v2:11","MinTileRow" : 0,"MaxTileRow" : 2047,"MinTileCol" : 0,"MaxTileCol" : 1915},
{"TileMatrix" : "EPSG2180v2:12","MinTileRow" : 0,"MaxTileRow" : 4095,"MinTileCol" : 0,"MaxTileCol" : 3830},
{"TileMatrix" : "EPSG2180v2:13","MinTileRow" : 0,"MaxTileRow" : 8191,"MinTileCol" : 0,"MaxTileCol" : 7660},
{"TileMatrix" : "EPSG2180v2:14","MinTileRow" : 0,"MaxTileRow" : 16383,"MinTileCol" : 0,"MaxTileCol" : 15321},
{"TileMatrix" : "EPSG2180v2:15","MinTileRow" : 0,"MaxTileRow" : 32767,"MinTileCol" : 0,"MaxTileCol" : 30642},
{"TileMatrix" : "EPSG2180v2:16","MinTileRow" : 0,"MaxTileRow" : 65535,"MinTileCol" : 0,"MaxTileCol" : 61284},
{"TileMatrix" : "EPSG2180v2:17","MaxTileRow" : 131071,"MinTileCol" : 0,"MaxTileCol" : 122569},
{"TileMatrix" : "EPSG2180v2:18","MinTileRow" : 0,"MaxTileRow" : 262143,"MinTileCol" : 0,"MaxTileCol" : 245138},
{"TileMatrix" : "EPSG2180v2:19","MaxTileRow" : 524287,"MinTileCol" : 0,"MaxTileCol" : 490276},
{"TileMatrix" : "EPSG2180v2:20","MaxTileRow" : 1048575,"MinTileCol" : 0,"MaxTileCol" : 980552},
{"TileMatrix" : "EPSG2180v2:21","MinTileRow" : 0,"MaxTileRow" : 2097151,"MinTileCol" : 0,"MaxTileCol" : 1961105},
{"TileMatrix" : "EPSG2180v2:22","MaxTileRow" : 4194303,"MinTileCol" : 0,"MaxTileCol" : 3922211}]}],"ResourceURL" : [{"format" : "image/png","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}?format=image/png","resourceType" : "tile"},
{"format" : "application/json;type=geojson","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}?format=application/json;type=geojson","resourceType" : "tile"},
{"format" : "application/vnd.mapbox-vector-tile","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}?format=application/vnd.mapbox-vector-tile","resourceType" : "tile"},
{"format" : "application/vnd.ogc.gml","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}/{J}/{I}?format=application/vnd.ogc.gml","resourceType" : "FeatureInfo"},
{"format" : "text/xml","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}/{J}/{I}?format=text/xml","resourceType" : "FeatureInfo"},
{"format" : "text/xml","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}/{J}/{I}?format=text/xml","resourceType" : "FeatureInfo"},
{"format" : "application/json","template" : url + "/rest/" + layerName + "/{style}/{TileMatrixSet}/{TileMatrix}/{TileRow}/{TileCol}/{J}/{I}?format=application/json","resourceType" : "FeatureInfo"}]},],"TileMatrixSet" : [{"Identifier" : "EPSG2180v2","SupportedCRS" : "urn:ogc:def:crs:EPSG::2180","TileMatrix" : [{"Identifier" : "EPSG2180v2:0","ScaleDenominator" : 5458804.235837181,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 1,"MatrixHeight" : 1},
{"Identifier" : "EPSG2180v2:1","ScaleDenominator" : 2729402.1179185905,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 2,"MatrixHeight" : 2},
{"Identifier" : "EPSG2180v2:2","ScaleDenominator" : 1364701.0589592953,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 4,"MatrixHeight" : 4},
{"Identifier" : "EPSG2180v2:3","ScaleDenominator" : 682350.5294796476,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 8,"MatrixHeight" : 8},
{"Identifier" : "EPSG2180v2:4","ScaleDenominator" : 341175.2647398238,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 15,"MatrixHeight" : 16},
{"Identifier" : "EPSG2180v2:5","ScaleDenominator" : 170587.6323699119,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 30,"MatrixHeight" : 32},
{"Identifier" : "EPSG2180v2:6","ScaleDenominator" : 85293.81618495595,"TopLeftCorner" : [908411, 144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 60,"MatrixHeight" : 64},
{"Identifier" : "EPSG2180v2:7","ScaleDenominator" : 42646.90809247798,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 120,"MatrixHeight" : 128},
{"Identifier" : "EPSG2180v2:8","ScaleDenominator" : 21323.45404623899,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 240,"MatrixHeight" : 256},
{"Identifier" : "EPSG2180v2:9","ScaleDenominator" : 10661.727023119494,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 479,"MatrixHeight" : 512},
{"Identifier" : "EPSG2180v2:10","ScaleDenominator" : 5330.863511559747,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 958,"MatrixHeight" : 1024},
{"Identifier" : "EPSG2180v2:11","ScaleDenominator" : 2665.4317557798736,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 1916,"MatrixHeight" : 2048},
{"Identifier" : "EPSG2180v2:12","ScaleDenominator" : 1332.7158778899368,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 3831,"MatrixHeight" : 4096},
{"Identifier" : "EPSG2180v2:13","ScaleDenominator" : 666.3579389449682,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 7661,"MatrixHeight" : 8192},
{"Identifier" : "EPSG2180v2:14","ScaleDenominator" : 333.1789694724843,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 15322,"MatrixHeight" : 16384},
{"Identifier" : "EPSG2180v2:15","ScaleDenominator" : 166.58948473624216,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 30643,"MatrixHeight" : 32768},
{"Identifier" : "EPSG2180v2:16","ScaleDenominator" : 83.29474236812108,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 61285,"MatrixHeight" : 65536},
{"Identifier" : "EPSG2180v2:17","ScaleDenominator" : 41.64737118406036,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 122570,"MatrixHeight" : 131072},
{"Identifier" : "EPSG2180v2:18","ScaleDenominator" : 20.82368559203036,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 245139,"MatrixHeight" : 262144},
{"Identifier" : "EPSG2180v2:19","ScaleDenominator" : 10.411842796015002,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 490277,"MatrixHeight" : 524288},
{"Identifier" : "EPSG2180v2:20","ScaleDenominator" : 5.205921398007501,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 980553,"MatrixHeight" : 1048576},
{"Identifier" : "EPSG2180v2:21","ScaleDenominator" : 2.602960699003929,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 1961106,"MatrixHeight" : 2097152},
{"Identifier" : "EPSG2180v2:22","ScaleDenominator" : 1.3014803495017857,"TopLeftCorner" : [908411,144693.28034703757],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 3922212,"MatrixHeight" : 4194304}]},
{"Identifier" : "EPSG:2180","SupportedCRS" : "urn:ogc:def:crs:EPSG::2180","TileMatrix" : [{"Identifier" : "EPSG:2180:0","ScaleDenominator" : 7559538.928571429,"TopLeftCorner" : [1208717,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 1,"MatrixHeight" : 1},
{"Identifier" : "EPSG:2180:1","ScaleDenominator" : 3779769.4642857146,"TopLeftCorner" : [1208717,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 2,"MatrixHeight" : 2},
{"Identifier" : "EPSG:2180:2","ScaleDenominator" : 1889884.7321428573,"TopLeftCorner" : [937783,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 3,"MatrixHeight" : 3},
{"Identifier" : "EPSG:2180:3","ScaleDenominator" : 944942.3660714286,"TopLeftCorner" : [937783,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 6,"MatrixHeight" : 6},
{"Identifier" : "EPSG:2180:4","ScaleDenominator" : 472471.1830357143,"TopLeftCorner" : [870049,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 12,"MatrixHeight" : 11},
{"Identifier" : "EPSG:2180:5","ScaleDenominator" : 236235.59151785716,"TopLeftCorner" : [870049,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 23,"MatrixHeight" : 22},
{"Identifier" : "EPSG:2180:6","ScaleDenominator" : 94494.25000000001,"TopLeftCorner" : [856503,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 57,"MatrixHeight" : 54},
{"Identifier" : "EPSG:2180:7","ScaleDenominator" : 47247.12500000001,"TopLeftCorner" : [856503,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 114,"MatrixHeight" : 108},
{"Identifier" : "EPSG:2180:8","ScaleDenominator" : 23623.562500000004,"TopLeftCorner" : [853116,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 228,"MatrixHeight" : 215},
{"Identifier" : "EPSG:2180:9","ScaleDenominator" : 9449.392857142859,"TopLeftCorner" : [851081,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 569,"MatrixHeight" : 536},
{"Identifier" : "EPSG:2180:10","ScaleDenominator" : 4724.696428571429,"TopLeftCorner" : [850404,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 1137,"MatrixHeight" : 1071},
{"Identifier" : "EPSG:2180:11","ScaleDenominator" : 1889.857142857143,"TopLeftCorner" : [850260,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 2843,"MatrixHeight" : 2677},
{"Identifier" : "EPSG:2180:12","ScaleDenominator" : 944.9285714285714,"TopLeftCorner" : [850125,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 5685,"MatrixHeight" : 5353},
{"Identifier" : "EPSG:2180:13","ScaleDenominator" : 472.4642857142857,"TopLeftCorner" : [850057,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 11370,"MatrixHeight" : 10705},
{"Identifier" : "EPSG:2180:14","ScaleDenominator" : 236.23214285714286,"TopLeftCorner" : [850023,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 22739,"MatrixHeight" : 21409},
{"Identifier" : "EPSG:2180:15","ScaleDenominator" : 118.11607142857143,"TopLeftCorner" : [850006,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 45477,"MatrixHeight" : 42817},
{"Identifier" : "EPSG:2180:16","ScaleDenominator" : 59.058035714285715,"TopLeftCorner" : [850006,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 90954,"MatrixHeight" : 85634},
{"Identifier" : "EPSG:2180:17","ScaleDenominator" : 29.529017857142858,"TopLeftCorner" : [850002,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 181907,"MatrixHeight" : 171267},
{"Identifier" : "EPSG:2180:18","ScaleDenominator" : 14.764508928571429,"TopLeftCorner" : [850000,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 363814,"MatrixHeight" : 342533},
{"Identifier" : "EPSG:2180:19","ScaleDenominator" : 7.382254464285714,"TopLeftCorner" : [850000,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 727627,"MatrixHeight" : 685066},
{"Identifier" : "EPSG:2180:20","ScaleDenominator" : 3.691127232142857,"TopLeftCorner" : [850000,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 1455254,"MatrixHeight" : 1370132},
{"Identifier" : "EPSG:2180:21","ScaleDenominator" : 1.8455636160714286,"TopLeftCorner" : [850000,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 2910508,"MatrixHeight" : 2740264},
{"Identifier" : "EPSG:2180:22","ScaleDenominator" : 0.9227818080357143,"TopLeftCorner" : [850000,100000],"TileWidth" : 512,"TileHeight" : 512,"MatrixWidth" : 5821015,"MatrixHeight" : 5480528}]}]}};
	return ldef;
  }

  getResolutionFromScale(scale) {
    var INCHES_PER_METER = 39.37;
    var BASE_DPI = 96;
    return (
      1 / ((1 / scale) * INCHES_PER_METER * BASE_DPI * window.devicePixelRatio)
    );
  }

  async getOlLayer(forHighResolution, forHistoricalData, _context) {
    const layerType = this.layer.type ? this.layer.type.toLowerCase() : null;
    switch (layerType) {
      case LayerTypes.wms:
        return this.getWmsLayer();
      case LayerTypes.wmsgc:
        return this.getWmsLayerFromUrl();
      case LayerTypes.raster:
        return this.getRasterLayer();
      case LayerTypes.wmts:
        let layer = await this.getWmtsLayer();
        return layer;
      case LayerTypes.point:
      case LayerTypes.multipoint:
      case LayerTypes.linestring:
      case LayerTypes.multilinestring:
      case LayerTypes.polygon:
      case LayerTypes.multipolygon:
      case LayerTypes.geometry:
        if (this.layer.isSystem) {
          if (forHighResolution) {
            return this.getVectorAsWmsLayer();
          }

          if (forHistoricalData) {
            return this.getHistoricalVectorLayer();
          }

          return await this.getVectorLayer(_context);
        } else {
          return await this.getGeojsonLayer(this.layer);
        }
      case LayerTypes.wfs:
        return this.getWfsLayer();
      case LayerTypes.wcs:
        return this.getWcsLayer();
      default:
        return null;
    }
  }

  updateOlLayer(forHistoricalData) {
    switch (this.layer.type) {
      case LayerTypes.point:
      case LayerTypes.multipoint:
      case LayerTypes.linestring:
      case LayerTypes.multilinestring:
      case LayerTypes.polygon:
      case LayerTypes.multipolygon:
      case LayerTypes.geometry:
        this.updateVectorAsWmsLayer(forHistoricalData);
        break;
      case LayerTypes.raster:
        this.updateRasterLayer();
        break;
    }
  }

  getWmsLayer() {
    let params = {
      LAYERS: this.layer.names ? this.layer.names.join(',') : this.layer.name,
      TILED: true,
      VERSION: '1.1.1'
    };
    const permissions = [...contextInstance.state.permissions];

    if (this.layer.names && this.layer.names.indexOf('pit:decyzja') !== -1) {
      if (permissions && permissions.length > 0) {
        //  jeśli ma uprawnienie do wszystkich - nie zakładamy żadnego filtra
        if (!permissions.includes('Registry_of_decision_all')) {
          // jeśli ma uprawnienie do własnych decyzji - zakładamy filtr organizacja = <ORGANIZACJA>
          if (permissions.includes('Registry_of_decision')) {
            params.CQL_FILTER = `organizacja=${contextInstance.state.organizationId}`;
          } else {
            // jeśli nie ma żadnych uprawnień - zakładamy filtr typu organizacja= -1
            params.CQL_FILTER = 'organizacja=-1';
          }
        }
      } else {
        // jeśli nie ma żadnych uprawnień - zakładamy filtr typu organizacja= -1
        params.CQL_FILTER = 'organizacja=-1';
      }
    }

    return new TileLayer({
      visible: this.layer.visible,
      zIndex: this.layer.order,
      minResolution:
        this.layer.scaleMin != null
          ? this.getResolutionFromScale(this.layer.scaleMin)
          : undefined,
      maxResolution:
        this.layer.scaleMax != null
          ? this.getResolutionFromScale(this.layer.scaleMax + 1)
          : undefined,
      opacity: this.layer.opacity || 1,

      source: new TileWMSSource({
        url: this.layer.url,
        params: params,
        projection: this.coordinateSystem,
        crossOrigin: '*'
      })
    });
  }

  async getWmtsLayer() {
    try {
      var url = this.fillUrl(this.layer.url, {
        REQUEST: 'GetCapabilities',
        SERVICE: 'WMTS'
      });
      let layerCapabilities = null;

	  if((this.layer.isSystem === true) || (this.layer.url.indexOf(settings.geoserverUrl)>=0)){
		layerCapabilities = this.getDefaultCapabilities();
	  } else{

	      if (window.wmtsLayersCapabilities) {
	        const foundItem = window.wmtsLayersCapabilities.find(
	          wmtsLayersSource => wmtsLayersSource.url === url
	        );
	        if (foundItem) {
	          // Create a copy of the layer source using Object.assign() or the spread operator
	          layerCapabilities = foundItem.layerCapabilities;
	        }
	      }
	  }
      if (!layerCapabilities) {
        const api = new ApiUslugi();
        const response = await api.getWmtsLayer(
          { url: url },
          {
            ignoreGlobalErrors: true,
            hasCsrfToken: false,
            withCredentials: false,
            hasContentType: false,
            jsonData: false
          }
        );
        const parser = new WMTSCapabilities();
        layerCapabilities = parser.read(response.body);

        if (!window.wmtsLayersCapabilities) {
          window.wmtsLayersCapabilities = [];
        }
        window.wmtsLayersCapabilities.push({
          url: url,
          layerCapabilities: layerCapabilities
        });
		if((this.layer.name==undefined) && ((Array.isArray(this.layer.names)) || (this.layer.names.length == 0))){
			if((layerCapabilities!=undefined) && (layerCapabilities.Contents!=undefined) && (layerCapabilities.Contents.Layer[0].Identifier)){
				this.layer.names.push(layerCapabilities.Contents.Layer[0].Identifier);
			}
		}
		if(!this.layer.title){
			if((layerCapabilities!=undefined) && (layerCapabilities.ServiceIdentification!=undefined) && (layerCapabilities.ServiceIdentification.Title)){
				this.layer.title = layerCapabilities.ServiceIdentification.Title;
			}
		}
      }
      const layer = await this.createWmtsLayerFromCapabilities(
        layerCapabilities
      );
      if (layer) {
        const headers = new Headers();
        headers.append('orgid', encodeURIComponent(contextInstance.state.organizationId || 0) );
        headers.append('Wso2_id',encodeURIComponent( contextInstance.state.email || 'Użytkownik niezalogowany'));
        headers.append('crossOrigin','*');

        layer.getSource().cqlFilter = null;
        layer.setCqlFilter = function(f) {
          let c = '';
          if (f) {
            for (var id in f) {
              c +=
                (c !== '' ? ';' : '') +
                id +
                '=' +
                encodeURIComponent(
                  typeof f[id] == 'string' ? "'" + f[id] + "'" : f[id]
                );
            }
          }

          this.getSource().cqlFilter = c != '' ? c : undefined;
          this.getSource().changed();
        };
        var selfLayerSource = layer.getSource();
        layer.getSource().setTileLoadFunction(function(imageTile, src) {
          if (selfLayerSource.cqlFilter != undefined)
            src +=
              (src.indexOf('?') > 0 ? '&' : '?') +
              'CQL_FILTER=' +
              selfLayerSource.cqlFilter;
          fetch(src, { mode: 'cors', headers: headers })
            .then(response => response.blob())
            .then(blob => {
              imageTile.getImage().src = URL.createObjectURL(blob);
            });
        });
      }

      return layer ? layer : null;
    } catch (e) {
      // throw `Usługa mapowa ${this.layer.url} nie odpowiada. Warstwy nie będą dostępne.`;
      throw ``;
    }
  }

  async createWmtsLayerFromCapabilities(capabilities) {

    const sourceOptions = optionsFromCapabilities(capabilities, {
      layer: this.layer.names ? this.layer.names[0] : this.layer.name
    });

    if (sourceOptions.projection.getCode() == 'EPSG:2180') {
      sourceOptions.tileGrid.origins_.forEach(origin => {
        const first = origin[0];
        origin[0] = origin[1];
        origin[1] = first;
      });
    }

    sourceOptions.crossOrigin = '*';

    if (this.layer.copyright && this.layer.copyright.attributions) {
      (sourceOptions.attributions = this.layer.copyright.attributions),
        document.styleSheets[document.styleSheets.length - 1].insertRule(
          '.ol-attribution.ol-uncollapsible { right: auto; left: 0px;}',
          0
        );
    }

    return new TileLayer({
      zIndex: this.layer.order,
      visible: this.layer.visible,
      minResolution:
        this.layer.scaleMin != null
          ? this.getResolutionFromScale(this.layer.scaleMin)
          : undefined,
      maxResolution:
        this.layer.scaleMax != null
          ? this.getResolutionFromScale(this.layer.scaleMax + 1)
          : undefined,
      source: new WMTSSource(sourceOptions)
    });
  }

  async createWmsLayerFromCapabilities(capabilities) {

	const projection = new Projection({
      code: "EPSG:2180",
      units: 'm',
      axisOrientation: 'enu'
      //axisOrientation: 'enu'
    });

	var names = this.layer.names.join(",");
	var extent = [90,90,0,0];

	if(Array.isArray(capabilities.Capability.Layer.EX_GeographicBoundingBox)){
		extent[0] = Math.min(extent[0],capabilities.Capability.Layer.EX_GeographicBoundingBox[0]);
		extent[1] = Math.min(extent[1],capabilities.Capability.Layer.EX_GeographicBoundingBox[1]);
		extent[2] = Math.max(extent[2],capabilities.Capability.Layer.EX_GeographicBoundingBox[2]);
		extent[3] = Math.max(extent[3],capabilities.Capability.Layer.EX_GeographicBoundingBox[3]);
	}
	try{
		if(names==""){
			if(capabilities.Capability.Layer.Name!=undefined){
				name = capabilities.Capability.Layer.Name;
			} else {
				for(var i=0;i<capabilities.Capability.Layer.Layer.length;i++){
					names += (i>0 ? "," : "") + capabilities.Capability.Layer.Layer[i].Name;
					if(Array.isArray(capabilities.Capability.Layer.Layer[i].EX_GeographicBoundingBox)){
						extent[0] = Math.min(extent[0],capabilities.Capability.Layer.Layer[i].EX_GeographicBoundingBox[0]);
						extent[1] = Math.min(extent[1],capabilities.Capability.Layer.Layer[i].EX_GeographicBoundingBox[1]);
						extent[2] = Math.max(extent[2],capabilities.Capability.Layer.Layer[i].EX_GeographicBoundingBox[2]);
						extent[3] = Math.max(extent[3],capabilities.Capability.Layer.Layer[i].EX_GeographicBoundingBox[3]);
					}
				}
			}
		}
	} catch (error) {
		  console.log("error: ");
		  console.log(error);
	}

	const sourceOptions = {
      url: (capabilities.Capability.Request.GetMap != undefined && capabilities.Capability.Request.GetMap.DCPType != undefined && capabilities.Capability.Request.GetMap.DCPType[0] != undefined && capabilities.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource != undefined) ? capabilities.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource : capabilities.Capability.Service.OnlineResource,
      params: {'LAYERS': names, 'TILED': true, 'VERSION': capabilities.version},
      transition: 0,
	  //crossOrigin: '*',
	  visible: true,
	  projection: "EPSG:2180"
    };

	var projectionExtent = extent[0] != 90 ? transformExtent(extent,'EPSG:4326',"EPSG:2180") : null;

	if(projectionExtent){

		var tItem = projectionExtent[1];
		projectionExtent[1] = projectionExtent[0];
		projectionExtent[0] = tItem;
		tItem = projectionExtent[3];
		projectionExtent[3] = projectionExtent[2];
		projectionExtent[2] = tItem;
	}

	const source = new TileWMSSource(sourceOptions);

	source.projection.axisOrientation_ = "neu";

	var tileLayerParams = {
      zIndex: this.layer.order,
      visible: this.layer.visible,
      minResolution: undefined,
      maxResolution: undefined,
      source: source
    };
	if(projectionExtent) tileLayerParams.extent = projectionExtent;
    var tileLayer = new TileLayer(tileLayerParams);

	if(capabilities.Service.Title) tileLayer.title = capabilities.Service.Title;
	tileLayer.extent = projectionExtent;
	tileLayer.names = names.split(',');
	return tileLayer;
  }

  async getVectorLayer(_context) {
    const coordinateSystem = 'EPSG:2180';
    const tileSize = [512, 512];
    const origin = [144693.2803470374, 908411.1932280732];

    const resolutions = [
      1528.4651860344106,
      764.2325930172053,
      382.11629650860266,
      191.05814825430133,
      95.52907412715066,
      47.76453706357533,
      23.882268531787666,
      11.941134265893833,
      5.9705671329469165,
      2.9852835664734583,
      1.4926417832367291,
      0.7463208916183646,
      0.3731604458091823,
      0.1865802229045911,
      0.0932901114522956,
      0.0466450557261478
    ];

    const projection = new Projection({
      code: coordinateSystem,
      units: 'm',
      axisOrientation: 'neu'
    });

    const headers = new Headers();
    headers.append(
      'orgid',
      encodeURIComponent(contextInstance.state.organizationId || 0)
    );
    headers.append(
      'Wso2_id',
      encodeURIComponent(
        contextInstance.state.email || 'Użytkownik niezalogowany'
      )
    );

    if (this.layer.datasource.startsWith('mvt_')) {
      const styleBuilder = new MapLayerStyleBuilder(this.style, this.layer);
      return new VectorTileLayer({
          declutter: true,
          visible: this.layer.visible,
          style: styleBuilder.getMVTStyle(),
          source: new VectorTileSource({
              tileLoadFunction: (tile, url) => {
                tile.setLoader(function (extent, resolution, projection) {
                  fetch(url, {headers: headers}).then(function (response) {
                    response.arrayBuffer().then(function (data) {
                      const format = tile.getFormat();
                      const features = format.readFeatures(data, {
                        extent: extent,
                        featureProjection: projection
                      });
                      tile.setFeatures(features);
                    });
                  });
                });
              },
              format: new MVTFormat(),
              urls: [settings.mapdataUrl + `${this.layer.datasource}/{z}/{x}/{y}`],
            projection: coordinateSystem,
            tileGrid: new TileGrid({
              extent: [
                144693.2803470374,
                125837.01797845494,
                927267.4555966556,
                908411.1932280732
              ],
              tileSize: tileSize,
              resolutions,
              origin,
            }),
          }),
      });
    }
    let gridNames = [];
    for (let i = 0; i <= resolutions.length; ++i) {
      gridNames.push(coordinateSystem + ':' + i);
    }
    let params = {
      REQUEST: 'GetTile',
      SERVICE: 'WMTS',
      VERSION: '1.0.0',
      LAYER: 'pit:' + this.layer.datasource,
      STYLE: 'generic',
      TILEMATRIX: coordinateSystem + ':{z}',
      TILEMATRIXSET: coordinateSystem,
      FORMAT: 'application/x-protobuf;type=mapbox-vector',
      TILECOL: '{x}',
      TILEROW: '{y}'
    };
    let url = this.fillUrl(settings.geoserverUrl + '/gwc/service/wmts', params);
    // Tutaj warstwy są wołane
    const deafaultScaleMax = 100000;
    //defaultScaleMax can be changed
    const deafaultScaleMin = 0;

    let maxResolution = this.getResolutionFromScale(
      Math.round(deafaultScaleMax / 4) + 1
    );

    let minResolution = this.getResolutionFromScale(deafaultScaleMin);

    return new VectorTileLayer({
      zIndex: this.layer.order,
      visible: this.layer.visible,
      minResolution: minResolution,
      maxResolution: maxResolution,
      source: new VectorTileSource({
        tileUrlFunction: function(coord) {
          return (
            url
              .replace('{z}', Math.abs(coord[0]))
              .replace('{x}', Math.abs(coord[1]))
              .replace('{y}', coord[2])
              .replace('EPSG:2180', 'EPSG2180v2') +
            '&CONTROL=' +
            new Date().getTime()
          );
        },
        tileLoadFunction: (tile, url) => {
          const _this = this;
          tile.setLoader(function (extent, resolution, projection) {
            fetch(url, {headers: headers}).then(function (response) {
              response.arrayBuffer().then(function (data) {
                const format = tile.getFormat();
                const features = format.readFeatures(data, {
                  extent: extent,
                  featureProjection: projection
                });
                const layerId = _this.layer.id;
                const tileLayersFeatures =
                  _context.rootGetters.tileLayersFeatures;
                let tileLayersFeaturesNew;
                tileLayersFeaturesNew = {
                  ...tileLayersFeatures,
                  [layerId]: [
                    ...(tileLayersFeatures[layerId] || []),
                    ...features
                  ]
                };
                _context.commit(
                  FEATURES_TILE_LAYERS_FEATURES_SET,
                  tileLayersFeaturesNew
                );
                tile.setFeatures(features);
              });
            });
          });
        },
        format: new MVTFormat(),
        projection: projection,
        tileGrid: new WMTSTileGrid({
          tileSize: tileSize,
          origin: origin,
          resolutions: resolutions,
          matrixIds: gridNames
        }),
        crossOrigin: '*'
      }),
      style: new MapLayerStyleBuilder(this.style, this.layer).getStyle()
    });
  }

  getVectorAsWmsLayer() {
    let minResolution = 30;
    if (this.layer.scaleMin) {
      let layerMinResolution = this.getResolutionFromScale(this.layer.scaleMin);
      if (minResolution < layerMinResolution) {
        minResolution = layerMinResolution;
      }
    }

    let maxResolution = undefined;
    if (this.layer.scaleMax) {
      const maxLayerResolution = this.getResolutionFromScale(
        this.layer.scaleMax + 1
      );
      if (maxLayerResolution <= 30) {
        minResolution = 0;
        maxResolution = 0;
      } else {
        maxResolution = maxLayerResolution;
      }
    }

    const org = contextInstance.state.organizationId;
    const permissions = [...contextInstance.state.permissions];
    let tileWMSSourceParams = {
      LAYERS: 'pit:' + this.layer.datasource,
      TILED: true,
      VERSION: '1.1.1',
      HEIGHT: 512,
      WIDTH: 512,
      STYLES: this.style.id
    };

    if (permissions && permissions.length > 0) {
      //  jeśli ma uprawnienie do wszystkich - nie zakładamy żadnego filtra
      if (!permissions.includes('Registry_of_decision_all')) {
        // jeśli ma uprawnienie do własnych decyzji - zakładamy filtr organizacja = <ORGANIZACJA>
        if (permissions.includes('Registry_of_decision')) {
          tileWMSSourceParams.CQL_FILTER = `organizacja=${org}`;
        } else {
          // jeśli nie ma żadnych uprawnień - zakładamy filtr typu organizacja= -1
          tileWMSSourceParams.CQL_FILTER = 'organizacja=-1';
        }
      }
    } else {
      // jeśli nie ma żadnych uprawnień - zakładamy filtr typu organizacja= -1
      tileWMSSourceParams.CQL_FILTER = 'organizacja=-1';
    }

    return new TileLayer({
      visible: this.layer.visible,
      zIndex: this.layer.order,
      minResolution: minResolution,
      maxResolution: maxResolution,
      source: new TileWMSSource({
        url:
          settings.geoserverUrl + '/wms' + '?CONTROL=' + new Date().getTime(),
        params: tileWMSSourceParams,
        projection: this.coordinateSystem,
        crossOrigin: '*'
      })
    });
  }

  getHistoricalVectorLayer() {
    return new TileLayer({
      visible: false,
      zIndex: this.layer.order,
      minResolution: this.layer.scaleMin
        ? this.getResolutionFromScale(this.layer.scaleMin)
        : undefined,
      maxResolution: this.layer.scaleMax
        ? this.getResolutionFromScale(this.layer.scaleMax)
        : undefined,
      source: new TileWMSSource({
        url: settings.geoserverUrl + '/wms',
        params: {
          LAYERS: this.historicalLayerName,
          TILED: true,
          VERSION: '1.1.1',
          HEIGHT: 512,
          WIDTH: 512,
          STYLES: this.style.id,
          TIME: moment.unix(this.layer.pointInThePast).toISOString()
        },
        projection: this.coordinateSystem,
        crossOrigin: '*'
      })
    });
  }

  updateVectorAsWmsLayer(forHistoricalData) {
    if (!this.layer.isSystem) return;

    if (forHistoricalData) {
      let layer = this.getHistoricalVectorLayer();

      if (this.layer.mapHistoricalLayer) {
        const source = layer.getSource();
        source.setCrossOrigin('*');
        this.layer.mapHistoricalLayer.setSource(layer.getSource());
      }
    } else {
      let layer = this.getVectorAsWmsLayer();

      if (this.layer.mapHighResolutionLayer) {
        const source = layer.getSource();
        // source.setCrossOrigin('*');
        this.layer.mapHighResolutionLayer.setSource(layer.getSource());
      }
    }
  }

  getVectorAsWmtsLayer(forHighResolution = true) {
    //let coordinateSystem = 'EPSG2180v2';
    let coordinateSystem = 'EPSG:2180';
    let tileSize = [512, 512];
    let origin = [144693.2803470374, 908411.1932280732];

    let resolutions = [
      1528.4651860344106,
      764.2325930172053,
      382.11629650860266,
      191.05814825430133,
      95.52907412715066,
      47.76453706357533,
      23.882268531787666,
      11.941134265893833,
      5.9705671329469165,
      2.9852835664734583,
      1.4926417832367291,
      0.7463208916183646,
      0.3731604458091823,
      0.1865802229045911,
      0.0932901114522956,
      0.0466450557261478
    ];

    let matrixIds = resolutions.map((x, i) => coordinateSystem + ':' + i);

    let minResolution = 30;
    let maxResolution = undefined;

    if (forHighResolution) {
      if (this.layer.scaleMin) {
        let layerMinResolution = this.getResolutionFromScale(
          this.layer.scaleMin
        );
        if (minResolution < layerMinResolution) {
          minResolution = layerMinResolution;
        }
      }

      if (this.layer.scaleMax) {
        const maxLayerResolution = this.getResolutionFromScale(
          this.layer.scaleMax + 1
        );
        if (maxLayerResolution <= 30) {
          minResolution = 0;
          maxResolution = 0;
        } else {
          maxResolution = maxLayerResolution;
        }
      }
    }

    return new TileLayer({
      zIndex: this.layer.order,
      visible: this.layer.visible,
      maxResolution: maxResolution,
      minResolution: minResolution,
      source: new WMTSSource({
        url: settings.geoserverUrl + '/gwc/service/wmts',
        layer: 'pit:' + this.layer.datasource,
        matrixSet: coordinateSystem,
        format: 'image/png',
        tileGrid: new WMTSTileGrid({
          tileSize: tileSize,
          origin: origin,
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: this.style.id,
		crossOrigin: '*',
        tileLoadFunction: function(tile, src) {
          const coord = tile.getTileCoord();
          tile.getImage().crossOrigin = '*';
          tile.getImage().src =
            src
              .replace('{z}', coord[0])
              .replace('{x}', coord[1])
              .replace('{y}', -coord[2] - 1) +
            '&CONTROL=' +
            new Date().getTime();
        }
      })
    });
  }

  getWfsLayer() {
    let params = {
      SERVICE: 'WFS',
      VERSION: '1.1.0',
      REQUEST: 'GetFeature',
      TYPENAME: encodeURIComponent(this.layer.names.join(',')),
      OUTPUTFORMAT: 'gml2',
      SRSNAME: this.coordinateSystem
    };

    let url = this.fillUrl(this.layer.url, params);

    let source = new VectorSource({
      format: new GML2Format(),
      loader: function(extent) {
        let requestUrl =
          url + '&BBOX=' + extent.join(',') + ',' + params.SRSNAME;

        let api = new ApiUslugi();
        api
          .getWfsProxy({
            wso2_id: this.contextEmail ? this.contextEmail : null,
            orgid: this.contextOrganizationId
              ? this.contextOrganizationId
              : null,
            url: requestUrl
          })
          .then(response => {
            let features = source.getFormat().readFeatures(response.body);
            source.addFeatures(features);
          })
          .catch(error => console.log(error));
      },
      strategy: bbox,
      crossOrigin: '*'
    });

    return new VectorLayer({
      zIndex: this.layer.order,
      visible: this.layer.visible,
      minResolution:
        this.layer.scaleMin != null
          ? this.getResolutionFromScale(this.layer.scaleMin)
          : undefined,
      maxResolution:
        this.layer.scaleMax != null
          ? this.getResolutionFromScale(this.layer.scaleMax + 1)
          : undefined,
      source: source,
      style: new MapLayerStyleBuilder(this.style, this.layer.type).getStyle()
    });
  }

  getWcsLayer() {
    var projectionExtent = transformExtent(
      [14.0745211117, 49.0273953314, 24.0299857927, 54.8515359564],
      'EPSG:4326',
      this.coordinateSystem
    );

    return new ImageLayer({
      extent: projectionExtent,
      zIndex: this.layer.order,
      minResolution:
        this.layer.scaleMin != null
          ? this.getResolutionFromScale(this.layer.scaleMin)
          : undefined,
      maxResolution:
        this.layer.scaleMax != null
          ? this.getResolutionFromScale(this.layer.scaleMax + 1)
          : undefined,
      source: new ImageWMSSource({
        url: this.layer.url,
        params: {
          LAYERS: this.layer.names.join(',')
        },
        crossOrigin: '*'
      })
    });
  }

  getRasterLayer() {
	let coordinateSystem = 'EPSG:2180';
    let tileSize = [512, 512];
    let origin = [144693.2803470374, 908411.1932280732];

    let resolutions = [
      1528.4651860344106,
      764.2325930172053,
      382.11629650860266,
      191.05814825430133,
      95.52907412715066,
      47.76453706357533,
      23.882268531787666,
      11.941134265893833,
      5.9705671329469165,
      2.9852835664734583,
      1.4926417832367291,
      0.7463208916183646,
      0.3731604458091823,
      0.1865802229045911,
      0.0932901114522956,
      0.0466450557261478
    ];

    let matrixIds = resolutions.map((x, i) => coordinateSystem + ':' + i);

    return new TileLayer({
      zIndex: this.layer.order,
      visible: this.layer.visible,
      minResolution:
        this.layer.scaleMin != null
          ? this.getResolutionFromScale(this.layer.scaleMin)
          : undefined,
      maxResolution:
        this.layer.scaleMax != null
          ? this.getResolutionFromScale(this.layer.scaleMax + 1)
          : undefined,
      source: new WMTSSource({
        url: settings.geoserverUrl + '/gwc/service/wmts',
        layer: this.layer.datasource + (this.layer.view3d ? '_3D' : ''),
        matrixSet: coordinateSystem,
        format: 'image/png',
        tileGrid: new WMTSTileGrid({
          tileSize: tileSize,
          origin: origin,
          resolutions: resolutions,
          matrixIds: matrixIds
        }),
        style: '',
        crossOrigin: '*'
      })
    });
  }

  updateRasterLayer() {
    let layer = this.getRasterLayer();
    let source = layer.getSource();
    if (source) {
      source.setCrossOrigin('*'); // Set cross-origin attribute
    }
    this.layer.mapLayer.setSource(source);
  }

  async getGeojsonLayer(layer) {
    try {
      const vectorLayerApi = new VectorLayerApi();
      return new VectorLayer({
        zIndex: this.layer.order,
        visible: this.layer.visible,
        source: new VectorSource({
          format: new GeoJSONFormat(),
          loader: function(extent) {
            const self = this;

            vectorLayerApi
              .getWarstwyWektoroweByIdObiekty({
                wso2_id: this.contextEmail ? this.contextEmail : null,
                orgid: this.contextOrganizationId
                  ? this.contextOrganizationId
                  : null,
                id: layer.id,
                bbox: extent.join(','),
                page_number: 0,
                items_per_page: 0
              })
              .then(response => {
                const features = self.getFormat().readFeatures(response.body);
                self.addFeatures(features);
              })
              .catch(_ => {
                self.removeLoadedExtent(extent);
              });
          },
          strategy: bbox,
          crossOrigin: '*'
        })
      });
    } catch (e) {
      // TODO obsługa błędu
      return null;
    }
  }

  async getWmsLayerFromUrl(){
	try {
      var url = this.fillUrl(this.layer.url, {
        REQUEST: 'GetCapabilities',
        SERVICE: 'WMS',
		VERSION: '1.1.1'
      });
      let layerCapabilities = null;

	  if (!layerCapabilities) {
        const api = new ApiUslugi();
        const response = await api.getWmsCapabilities(
          { url: url },
          {
            ignoreGlobalErrors: true,
            hasCsrfToken: false,
            withCredentials: false,
            hasContentType: false,
            jsonData: false
          }
        );
        const parser = new WMSCapabilities();
        layerCapabilities = parser.read(response.body);
      }

      const layer = await this.createWmsLayerFromCapabilities(
        layerCapabilities
      );
	  if(layerCapabilities){
		if(!this.layer.title) this.layer.title = layerCapabilities.Service.TItle;
	  } else {
		console.log("empty layerCapabilities");
	  }
	  //console.log("layer: ");
      /*if (layer) {
        const headers = new Headers();
        headers.append('crossOrigin','*');

        var selfLayerSource = layer.getSource();
        layer.getSource().setTileLoadFunction(function(imageTile, src) {
          fetch(src, { mode: 'cors', headers: headers })
            .then(response => response.blob())
            .then(blob => {
              imageTile.getImage().src = URL.createObjectURL(blob);
            });
        });
      }*/

      return layer ? layer : null;
    } catch (e) {
      // throw `Usługa mapowa ${this.layer.url} nie odpowiada. Warstwy nie będą dostępne.`;
      throw ``;
    }
  }

  fillUrl(url, params) {
    let queryStringIndex = url.indexOf('?');

    if (queryStringIndex >= 0) {
      url = url.substring(0, queryStringIndex) + '?';
    } else {
      url += '?';
    }

    for (var param in params) {
      url = url + param + '=' + params[param] + '&';
    }

    url = url.slice(0, -1);

    return url;
  }
}
